"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
function BackArrow(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { className: "icon ".concat(className), height: "".concat(height), viewBox: '0 0 52 52', width: "".concat(width) },
        React.createElement("path", { clipRule: 'evenodd', d: 'M34.032 11.468a2.167 2.167 0 010 3.064L22.564 26l11.468 11.468a2.167 2.167 0 01-3.064 3.064l-13-13a2.167 2.167 0 010-3.064l13-13a2.167 2.167 0 013.064 0z', fill: '#fff', fillRule: 'evenodd' })));
}
BackArrow.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
BackArrow.defaultProps = {
    width: 64,
    height: 64,
};
exports.default = BackArrow;
